import React from 'react'
import { useIntl } from 'react-intl'
import Button from './index'

const DeleteButton = ({ onClick, isDisabled, btnClass }) => {
  const { formatMessage: msg } = useIntl()

  return (
    <Button
      btnType="button"
      btnText={msg({ id: 'button.delete' })}
      btnClass={btnClass || 'btn-icon'}
      iconLeft
      iconSize="1rem"
      iconClass="pi pi-trash"
      onHandleClick={onClick}
      isDisabled={isDisabled}
    />
  )
}

export default DeleteButton
